import type { Usuario } from "@/ts/typings/clases";
import { TypedTable } from "@/components/ui/table/TypedTable";
import { useMemo, useState } from "react";
import { ModalMaquinas } from "./components/ModalMaquinasUsuario";
import { ModalEliminarUsuario } from "./components/ModalEliminarUsuario";
import { createColumnHelper, tableFeatures } from "@tanstack/react-table";
import { ModalEditarUsuario } from "./components/ModalEditarUsuario";
import { useUsuarios } from "./GestionUsuarios";
import { CommonFeatures } from "@/hooks/useTanstackTable";

export function TablaUsuarios() {
	const { data, error, isPending } = useUsuarios();

	const [modalDelete, setModalDelete] = useState<Usuario | null>(null);
	const [modalEdit, setModalEdit] = useState<Usuario | null>(null);
	const [modalMaquinas, setModalMaquinas] = useState<Usuario | null>(null);


	const { columns, features } = useMemo(() => Columns(setModalDelete, setModalEdit, setModalMaquinas), [setModalDelete, setModalEdit, setModalMaquinas]);

	return (
		<>
			<TypedTable
				className="dataTable display"
				data={data ?? []}
				columns={columns}
				features={features}

				noResultsMessage="No se encontraron usuarios"
				errorMessage={error?.message ?? "Error al cargar los usuarios"}
				isLoading={isPending}
				isError={error != null}
			/>

			<ModalMaquinas shown={modalMaquinas != null} close={() => { setModalMaquinas(null); }} usuario={modalMaquinas} />
			<ModalEliminarUsuario show={modalDelete != null} close={() => { setModalDelete(null); }} usuario={modalDelete} />
			<ModalEditarUsuario shown={modalEdit != null} close={() => { setModalEdit(null); }} usuario={modalEdit} />
		</>
	);
}


interface AccionesUsuarioProps {
	readonly usuario: Usuario;
	readonly setModalDelete: (usuario: Usuario) => void;
	readonly setModalEdit: (usuario: Usuario) => void;
	readonly setModalMaquinas: (usuario: Usuario) => void;
}
function AccionesUsuario(props: AccionesUsuarioProps) {
	const puestosLimitados = props.usuario.rol == "operario" || props.usuario.rol == "montador";
	return (
		<div className="accionesUsuario">
			<button onClick={() => { props.setModalEdit(props.usuario); }} type="button">
				<i className="fa fa-pen-to-square" />
			</button>
			<button onClick={() => { props.setModalDelete(props.usuario); }} type="button">
				<i className="fa fa-delete-left" />
			</button>
			{puestosLimitados ? (
				<button onClick={() => { props.setModalMaquinas(props.usuario); }} type="button">
					<i className="fa fa-gear" />
				</button>
			) : <div />}
		</div>
	);
}




function Columns(setModalDelete: (usuario: Usuario) => void, setModalEdit: (usuario: Usuario) => void, setModalMaquinas: (usuario: Usuario) => void) {
	const columnHelper = createColumnHelper<typeof features, Usuario>();
	const features = tableFeatures(CommonFeatures);

	const dictRol = {
		"jefeFabrica": "Jefe de fabrica",
		"administracion": "Administración",
		"admin": "Administrador Global",
		"carretillero": "Carretillero",
		"montador": "Montador",
		"operario": "Operario",
	};
	const getAccionesUsuario = (usuario: Usuario) => (
		<AccionesUsuario
			usuario={usuario}
			setModalDelete={setModalDelete}
			setModalEdit={setModalEdit}
			setModalMaquinas={setModalMaquinas}
		/>
	);

	const columns = columnHelper.columns([
		columnHelper.accessor("nombre", { header: "Nombre" }),
		columnHelper.accessor("apellido", { header: "Apellido" }),
		columnHelper.accessor("email", { header: "E-mail" }),
		columnHelper.accessor("rol", { header: "Rol", cell: info => dictRol[info.getValue()] }),
		columnHelper.display({
			id: "acciones",
			header: "",
			meta: {
				className: "p-0 h-full",
			},
			cell: ({ row }) => getAccionesUsuario(row.original),
		}),
		// { title: "", render: (linea) => dictRol[linea.rol] },
	]);
	return { columns, features };
}